import { staticGoogleMapUrl } from '../StaticGoogleMap';
import { PluginWorkSite } from 'rwl-shared/dist/models/plugin/Plugin';
import { standardMarkerBuilder } from '../Map/Markers/WorkSiteMarker';
import styled from 'styled-components6';
import { Icons } from '../Map';

const MapDiv = styled.div`
    background-position: center;
    background-size: cover;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: var(--rwl-radius-sm);
`;

export const JobMap = ({ worksite }: { worksite: PluginWorkSite }) => {
    if (!worksite.geolocation) {
        return null;
    }

    const primaryMapColor = window
        .getComputedStyle(document.documentElement)
        .getPropertyValue('--rwl-color-primary-map');

    const svg = standardMarkerBuilder(worksite, undefined, {
        iconSymbol: Icons.HOUSE_ICON,
        size: 40,
        color: primaryMapColor,
        includeAnchor: false,
    });

    return (
        <MapDiv
            id={'jobMap-' + worksite.id}
            style={{
                backgroundImage: `url(${staticGoogleMapUrl({
                    center: worksite.geolocation,
                    zoom: 11,
                    size: {
                        width: 400,
                        height: 200,
                    },
                })})`,
            }}
        >
            <img
                alt={'map of job location'}
                src={svg.icon.url}
                style={{
                    width: svg.shape?.coords?.[3] || 80,
                    height: svg.shape?.coords?.[2] || 60,
                }}
            />
        </MapDiv>
    );
};
